
namespace RioERP.Inventory {
    export class PendriveInwardColumns {
        static columnsKey = 'Inventory.PendriveInward';
    }
}